/* eslint-disable import/no-dynamic-require */
/* eslint-disable @typescript-eslint/no-var-requires */
import { IDataPages } from 'common/contracts';
import { LoadingWrap } from 'common/styles/Modal.styles';
import Breadcrumb, { IBreadcrumb } from 'components/BreadCrumb/Breadcrumb';
import DetailsButton from 'components/DetailsToggleButton/DetailsButton.toggle';
import LogoIcon from 'components/LogoIcon/LogoIcon';
import PrimaryModal from 'components/Modal/PrimaryModal';
import SecondaryModal from 'components/Modal/SecondaryModal';
import PointComp from 'components/PointComp/PointComp';
import { pageData } from 'data/pages';
import { DataCenterContainer } from 'pages/Facility/DataCenter.styles';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import DataCenterModalContentService from 'services/modalContent/dataCenter/DataCenterModalContent.service';
import {
  setPrimaryModalContentOf,
  setSecondaryModalContentOf,
  updatePrimaryModalVisibility,
  updateSecondaryModalVisibility
} from 'store/slices/ModalSlice';
import { toCamelCase } from 'utils/callbacks';

const Facility = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { params } = useRouteMatch<{ facility: string; room: string; product: string }>();

  const [roomList, setRoomList] = useState<IDataPages[]>([]);
  const [currentPageData, setCurrentPageData] = useState<IDataPages>();

  const modalService = new DataCenterModalContentService();

  const breadcrumbs: IBreadcrumb[] = [
    {
      title: 'Home',
      link: '/',
      active: false
    },
    {
      title: toCamelCase(params.facility),
      link: `/${params.facility}`,
      active: true
    }
  ];

  const containerRef = useRef<HTMLDivElement>(null);

  const handlePointClick = (item: IDataPages) => {
    // dispatch(updatePrimaryModalVisibility(true));
    // dispatch(setPrimaryModalContentOf(item.route));
    history.push(`${params.facility}/${item.route}`);
  };

  useEffect(() => {
    if (!params.room) {
      dispatch(updatePrimaryModalVisibility(false));
      dispatch(setPrimaryModalContentOf(''));
    }
    if (!params.product) {
      dispatch(updateSecondaryModalVisibility(false));
      dispatch(setSecondaryModalContentOf(''));
    }
  }, [params.room, params.product, dispatch]);

  useEffect(() => {
    // filter children of city scape

    const r = pageData.filter(item => item.parentRoute === params.facility);
    const currentPage = pageData.find(item => item.route === params.facility);

    setRoomList(r);
    setCurrentPageData(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {currentPageData ? (
        <>
          <Breadcrumb breadcrumbs={breadcrumbs} />
          <LogoIcon />
          <DetailsButton title={currentPageData.title} descerption={currentPageData.content} />
          <DataCenterContainer ref={containerRef}>
            <img
              src={
                // eslint-disable-next-line global-require
                require(`../../assets/images/rooms/${currentPageData.route}/${currentPageData.backgroundImage}`).default
              }
              alt={currentPageData.title}
            />
            <>
              {roomList.map((item: IDataPages, idx: number) => (
                <PointComp key={idx} position={item.pos} handleClick={() => handlePointClick(item)}>
                  {item.label}
                </PointComp>
              ))}
            </>
          </DataCenterContainer>
          <PrimaryModal modalService={modalService} />
          <SecondaryModal modalService={modalService} />
        </>
      ) : (
        <LoadingWrap>Loading</LoadingWrap>
      )}
    </>
  );
};

export default Facility;
